import { Dictionary } from "./Dictionary";

export default new class Translations {

	constructor() {
		this.switchLanguage('cs');
	}

	switchLanguage(lang) {
		window.t = {};
		let i = 0;
		for (let ns in Dictionary.keys) {
			for (let key in Dictionary.keys[ns]) {
				window.t[ns + Dictionary.keys[ns][key]] = Dictionary.languages[lang][i];
				i++;
			}
		}
		window.t.weekDayShort = function (day) {
			return $.fn.datepicker.dates[t.langCode].daysMin[day];
		};
		window.t.formatDate = function (val) {
			if (val) {
				val += '';
				let d = new Date(Date.UTC(val.substr(0, 4), val.substr(4, 2) - 1, val.substr(6, 2)));
				return $.fn.datepicker.DPGlobal.formatDate(d, t.commonFormatDate, t.langCode);
			}
			return '';
		}
		window.t.formatDatetime = function (milliseconds) {
			if (!milliseconds) return null;
			let d = new Date(milliseconds);
			d.setTime(d.getTime() + d.getTimezoneOffset() * 60 * 1000);
			return $.fn.datepicker.DPGlobal.formatDate(d, t.commonFormatDate, lang) + " " + d.getHours() + ":" + (d.getMinutes() < 10 ? "0" : "") + d.getMinutes();
		}
		window.t.formatMonth = function (val) {
			if (val)
				val += '';
			return val ? val.substr(4, 2) + "/" + val.substr(0, 4) : '';
		}
		window.t.formatInt = function (value) {
			return value?.toLocaleString();
		}
		window.t.formatHours = function (value) {
			let m = value % 60;
			let h = (value - m) / 60;
			return h + ":" + (m < 10 ? "0" : "") + m;
		}
		window.t.price = function (value, currencyId) {
			if (!value && value !== 0) return;
			return value.toLocaleString('cs-CZ', { minimumFractionDigits: 2 }) + (currencyId ? ' ' + window.t.currencies[currencyId][0] : ' ---');
		}
		window.t.fileSize = function (bytes) {
			const thresh = 1024;
			if (Math.abs(bytes) < thresh) return bytes + ' B';
			const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
			let u = -1;
			do {
				bytes /= thresh;
				++u;
			} while (Math.round(Math.abs(bytes) * 10) / 10 >= thresh && u < units.length - 1);

			return bytes.toFixed(1) + ' ' + units[u];
		}
		window.T = function (str) {
			if (Array.isArray(str)) {
				if (t[str[0]] == undefined)
					return str;
				str[0] = t[str[0]];
				for (let i = 1; i < str.length; i++) {
					if (str[i].match(/d(\d){8}/))
						str[i] = t.formatDate(str[i].substr(1));
					else if (str[i].match(/m(\d){6}/))
						str[i] = t.formatMonth(str[i].substr(1));
					str[0] = str[0].replace("{" + (i - 1) + "}", str[i]);
				}
				return str[0];
			}
			if (t[str] == undefined)
				return str;
			return t[str];
		}

	}

}